interface SplitFormat {
  dateOnlyFormat: string;
  dateTimeFormat: string;
}

function splitDateTimeFormat(formatString: string): SplitFormat {
  const cleaned = formatString.replace(/\s+/g, "");

  if (/T/i.test(cleaned)) {
    const parts = cleaned.split(/T/i);
    return { dateOnlyFormat: parts[0], dateTimeFormat: cleaned };
  }

  const timeIndex = cleaned.search(/[hH]/);
  if (timeIndex === -1) {
    return { dateOnlyFormat: cleaned, dateTimeFormat: cleaned };
  }

  const dateOnlyFormat = cleaned.substring(0, timeIndex);
  return { dateOnlyFormat, dateTimeFormat: cleaned };
}

export default splitDateTimeFormat;
